export const contractType = ['cdi', 'cdd', 'interim'] as const
export type ContractType = (typeof contractType)[number]

export const contractTypeLabel: Record<ContractType, string> = {
  cdi: 'CDI',
  cdd: 'CDD',
  interim: 'Interim',
}
